import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import { SelectWrapper } from '../../../../shared/SettingsModal/StyledComponents';
import { StyledSelect } from '../../../../shared/FormStyles';

import { useFetchAudiences } from '../../hooks/useFetchAudiences';
import { useBroadcastContext } from '../../contexts/BroadcastContext.jsx';

export const SegmentTargeting = () => {
  const { t } = useTranslation('broadcasts');
  const audienceOptions = useFetchAudiences();
  const ALL_CONTACTS = t('audience.allContacts');
  const TARGET_BY_AUDIENCE = t('audience.targetByAudience');
  const TABS = [ALL_CONTACTS, TARGET_BY_AUDIENCE];
  const {
    values: { uuid, audiences },
    createBroadcastOnAudience,
    updateAudiences,
  } = useBroadcastContext();
  const [activeTab, setActiveTab] = useState('');

  const handleOnChange = selectedAudiences => {
    // react-select returns null when cleared, normalize to empty array
    const audiences = selectedAudiences || [];
    if (uuid) {
      updateAudiences(audiences);
    } else {
      createBroadcastOnAudience(audiences);
    }
  };

  const handleTabChange = tab => {
    if (tab === ALL_CONTACTS && audiences.length) {
      updateAudiences([]);
    }

    setActiveTab(tab);
  };

  useEffect(() => {
    if (audiences.length) {
      setActiveTab(TARGET_BY_AUDIENCE);
    } else {
      setActiveTab(ALL_CONTACTS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  return (
    <>
      <TabContainer>
        {TABS.map(tab => (
          <Tab
            key={tab}
            variant={activeTab === tab ? 'active' : ''}
            onClick={() => handleTabChange(tab)}
          >
            <Text variant="subtitle1">{tab}</Text>
          </Tab>
        ))}
      </TabContainer>
      {activeTab === TARGET_BY_AUDIENCE && (
        <SelectContainer>
          <StyledSelect
            onChange={handleOnChange}
            className="audience-filter"
            classNamePrefix="react-select"
            placeholder={t('audience.chooseAudiences')}
            value={audiences}
            isClearable={true}
            options={audienceOptions}
            isSearchable={true}
            isMulti={true}
          />
        </SelectContainer>
      )}
    </>
  );
};

const SelectContainer = styled(SelectWrapper)`
  padding: 20px 20px 0px 20px;
  margin-top: 0px;
`;

const TabContainer = styled.div`
  display: flex;
  margin: 20px 20px 0px 20px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #eaecf0;
  background: ${themeGet('colors.black.5')};
`;

const Tab = styled.div`
  line-height: 24px;
  cursor: pointer;
  color: ${themeGet('colors.black.80')};
  padding: 8px 12px;
  margin-right: 20px;

  &:last-child {
    margin: 0;
  }

  &:hover {
    color: ${themeGet('colors.primary.80')};
  }

  ${variant({
    variants: {
      active: {
        borderRadius: '6px',
        background: 'white',
        boxShadow:
          '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
      },
    },
  })}
`;
